import { BaseModel } from '@/api/base-model'
import { TypeformFormAPI } from '@/api/backend-client'
import { TypeformResponseDefinitionField } from '@/api/model/typeform/typeform-response-definition-field'

export class TypeformResponseDefinition extends BaseModel<TypeformResponseDefinition> {
    protected collectionName = TypeformFormAPI.collectionName

    constructor(
        public formId: string,
        public formTitle: string,
        public fields: TypeformResponseDefinitionField[],
    ) { super(null) }

    toRequestData(): any {
        return {
            formId: this.formId,
            formTitle: this.formTitle,
            fields: this.fields.map(entry => entry.toRequestData()),
        }
    }

    static fromData(data: any): TypeformResponseDefinition {
        if (data === null || typeof data === 'string' || data instanceof TypeformResponseDefinition) {
            return data
        }

        return new TypeformResponseDefinition(
            data.formId,
            data.formTitle,
            Object.values(data.fields || {}).map(entry => TypeformResponseDefinitionField.fromData(entry)),
        )
    }
}
